var styles = {
  "Header": "Online-Store-UI-Header_jfxek",
  "show": "Online-Store-UI-Header--show_495v3",
  "slow": "Online-Store-UI-Header--slow_495v0",
  "Interior": "Online-Store-UI-Header__Interior_1vvcx"
};

export { styles as default };
